import { render, staticRenderFns } from "./EquipamentsInactive.vue?vue&type=template&id=2b35a559&scoped=true&"
import script from "./EquipamentsInactive.vue?vue&type=script&lang=js&"
export * from "./EquipamentsInactive.vue?vue&type=script&lang=js&"
import style0 from "./EquipamentsInactive.vue?vue&type=style&index=0&id=2b35a559&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b35a559",
  null
  
)

export default component.exports